// This file is auto-generated by @hey-api/openapi-ts

export const AccountLookupConfigSchema = {
  oneOf: [
    {
      type: "object",
      properties: {
        disabled: {
          type: "boolean",
          enum: [false],
        },
        supportUrl: {
          type: "string",
          minLength: 1,
        },
      },
      required: ["supportUrl"],
    },
    {
      type: "object",
      properties: {
        disabled: {
          type: "boolean",
          enum: [true],
        },
        supportUrl: {
          type: "string",
        },
      },
      required: ["disabled"],
    },
  ],
} as const;

export const AdminLoginSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/SSOLogin",
    },
    {
      $ref: "#/components/schemas/EmailLogin",
    },
  ],
  discriminator: {
    propertyName: "method",
    mapping: {
      sso: "#/components/schemas/SSOLogin",
      email: "#/components/schemas/EmailLogin",
    },
  },
} as const;

export const Auth0ConfigSchema = {
  type: "object",
  properties: {
    disabled: {
      type: "boolean",
    },
    clientId: {
      type: "string",
    },
  },
  required: ["clientId"],
} as const;

export const AvelaAIConfigSchema = {
  oneOf: [
    {
      type: "object",
      properties: {
        enabled: {
          type: "boolean",
          enum: [false],
        },
      },
      required: ["enabled"],
    },
    {
      type: "object",
      properties: {
        enabled: {
          type: "boolean",
          enum: [true],
        },
        document_start_date: {
          type: "string",
          format: "date-time",
        },
      },
      required: ["enabled", "document_start_date"],
    },
  ],
  default: {
    enabled: false,
  },
} as const;

export const BrandingConfigSchema = {
  type: "object",
  properties: {
    disabled: {
      type: "boolean",
    },
    name: {
      type: "string",
      minLength: 1,
    },
    colors: {
      $ref: "#/components/schemas/BrandingConfigColors",
    },
    logos: {
      $ref: "#/components/schemas/BrandingConfigLogos",
    },
    message: {
      $ref: "#/components/schemas/BrandingConfigMessage",
    },
  },
  default: {
    name: "Avela",
    colors: {
      primary: {
        50: "#ECEEF8",
        100: "#CBCEEC",
        200: "#A9AFDF",
        300: "#888FD3",
        400: "#6670C7",
        500: "#4551BA",
        600: "#374195",
        700: "#293070",
        800: "#1B204B",
        900: "#0E1025",
      },
    },
    logos: {
      whiteSvg:
        "https://prod.config.avela.org/organization/v1/avela/logos/avela-logo.svg",
      colorSvg:
        "https://prod.config.avela.org/organization/v1/avela/logos/avela-logo-color.svg",
      whitePng:
        "https://prod.config.avela.org/organization/v1/avela/logos/avela-logo.png",
      colorPng:
        "https://prod.config.avela.org/organization/v1/avela/logos/avela-logo-color.png",
    },
    message: {
      footer: `Please do not reply to this email, the account does not accept responses and you won't get a reply.<br /><br />
Por favor no responda a este correo electrónico, la cuenta no acepta respuestas y no recibirá contestación.`,
      replyTo: "",
    },
  },
  required: ["name", "colors", "logos", "message"],
} as const;

export const BrandingConfigColorsSchema = {
  type: "object",
  properties: {
    primary: {
      type: "object",
      properties: {
        50: {
          type: "string",
          pattern: "^#([A-Fa-f0-9]{6})$",
        },
        100: {
          type: "string",
          pattern: "^#([A-Fa-f0-9]{6})$",
        },
        200: {
          type: "string",
          pattern: "^#([A-Fa-f0-9]{6})$",
        },
        300: {
          type: "string",
          pattern: "^#([A-Fa-f0-9]{6})$",
        },
        400: {
          type: "string",
          pattern: "^#([A-Fa-f0-9]{6})$",
        },
        500: {
          type: "string",
          pattern: "^#([A-Fa-f0-9]{6})$",
        },
        600: {
          type: "string",
          pattern: "^#([A-Fa-f0-9]{6})$",
        },
        700: {
          type: "string",
          pattern: "^#([A-Fa-f0-9]{6})$",
        },
        800: {
          type: "string",
          pattern: "^#([A-Fa-f0-9]{6})$",
        },
        900: {
          type: "string",
          pattern: "^#([A-Fa-f0-9]{6})$",
        },
      },
      required: [
        "50",
        "100",
        "200",
        "300",
        "400",
        "500",
        "600",
        "700",
        "800",
        "900",
      ],
    },
  },
  required: ["primary"],
} as const;

export const BrandingConfigLogosSchema = {
  type: "object",
  properties: {
    whiteSvg: {
      type: "string",
      format: "uri",
    },
    colorSvg: {
      type: "string",
      format: "uri",
    },
    whitePng: {
      type: "string",
      format: "uri",
    },
    colorPng: {
      type: "string",
      format: "uri",
    },
  },
  required: ["whiteSvg", "colorSvg", "whitePng", "colorPng"],
} as const;

export const BrandingConfigMessageSchema = {
  type: "object",
  properties: {
    footer: {
      type: "string",
    },
    replyTo: {
      anyOf: [
        {
          type: "string",
          format: "email",
        },
        {
          type: "string",
          enum: [""],
        },
      ],
      default: "",
    },
  },
  required: ["footer"],
} as const;

export const ContactConfigSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/EmailContact",
    },
    {
      $ref: "#/components/schemas/PhoneContact",
    },
    {
      $ref: "#/components/schemas/LinkContact",
    },
  ],
  discriminator: {
    propertyName: "type",
    mapping: {
      email: "#/components/schemas/EmailContact",
      phone: "#/components/schemas/PhoneContact",
      link: "#/components/schemas/LinkContact",
    },
  },
} as const;

export const ContactsConfigSchema = {
  type: "object",
  properties: {
    disabled: {
      type: "boolean",
    },
    path: {
      type: "string",
    },
    contacts: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ContactConfig",
      },
    },
  },
  default: {
    path: "demo",
    contacts: [
      {
        label: "Email support",
        type: "email",
        value: "help@avela.org",
      },
      {
        label: "Call support",
        type: "phone",
        value: "+14155551212",
      },
      {
        label: "Avela main weblink",
        type: "link",
        value: "https://avela.org/?src=default",
      },
      {
        label: "Avela help",
        type: "link",
        value:
          "https://avelahelp.zendesk.com/hc/en-us/categories/10538297840269-Support-for-Families",
      },
    ],
  },
  required: ["path", "contacts"],
} as const;

export const EmailContactSchema = {
  type: "object",
  properties: {
    label: {
      type: "string",
      minLength: 1,
      maxLength: 60,
    },
    type: {
      type: "string",
      enum: ["email"],
    },
    value: {
      type: "string",
      maxLength: 320,
      format: "email",
    },
  },
  required: ["label", "type", "value"],
} as const;

export const EmailLoginSchema = {
  type: "object",
  properties: {
    method: {
      type: "string",
      enum: ["email"],
    },
  },
  required: ["method"],
} as const;

export const ErrorSchema = {
  type: "object",
  properties: {
    message: {
      type: "string",
      description: "Error message",
    },
  },
  required: ["message"],
} as const;

export const ErrorResponseSchema = {
  type: "object",
  properties: {
    error: {
      $ref: "#/components/schemas/Error",
    },
    requestId: {
      type: "string",
      description: "Server-generated request ID",
    },
  },
  required: ["error", "requestId"],
} as const;

export const ExternalCapacitySchema = {
  type: "object",
  properties: {
    disabled: {
      type: "boolean",
    },
    enabled: {
      type: "boolean",
    },
    title: {
      type: "string",
    },
    description: {
      type: "string",
    },
    enrollmentPeriodIds: {
      type: "array",
      items: {
        type: "string",
        format: "uuid",
      },
    },
    showPrograms: {
      type: "boolean",
    },
    showWaitlist: {
      type: "boolean",
    },
    seatBands: {
      type: "array",
      items: {
        type: "object",
        properties: {
          key: {
            type: "string",
            minLength: 1,
          },
          label: {
            type: "string",
            minLength: 1,
          },
          description: {
            type: "string",
          },
          colorScheme: {
            type: "string",
            enum: [
              "green",
              "teal",
              "blue",
              "purple",
              "yellow",
              "orange",
              "red",
              "gray",
            ],
          },
          minCount: {
            type: "integer",
            minimum: 0,
          },
        },
        required: ["key", "label", "colorScheme", "minCount"],
      },
      minItems: 1,
    },
    waitlistBands: {
      type: "array",
      items: {
        type: "object",
        properties: {
          key: {
            type: "string",
            minLength: 1,
          },
          label: {
            type: "string",
            minLength: 1,
          },
          description: {
            type: "string",
          },
          colorScheme: {
            type: "string",
            enum: [
              "green",
              "teal",
              "blue",
              "purple",
              "yellow",
              "orange",
              "red",
              "gray",
            ],
          },
          minCount: {
            type: "integer",
            minimum: 0,
          },
        },
        required: ["key", "label", "colorScheme", "minCount"],
      },
      minItems: 1,
    },
  },
  default: {
    enabled: false,
    title: "Seat availability",
    description: "",
    enrollmentPeriodIds: [],
    showPrograms: true,
    showWaitlist: true,
    seatBands: [
      {
        key: "open",
        label: "Seats available",
        colorScheme: "green",
        minCount: 10,
      },
      {
        key: "limited",
        label: "Limited seats",
        colorScheme: "yellow",
        minCount: 1,
      },
      {
        key: "full",
        label: "No seats available",
        colorScheme: "red",
        minCount: 0,
      },
    ],
    waitlistBands: [
      {
        key: "long",
        label: "Long waitlist",
        colorScheme: "red",
        minCount: 25,
      },
      {
        key: "short",
        label: "Short waitlist",
        colorScheme: "yellow",
        minCount: 1,
      },
      {
        key: "none",
        label: "No waitlist",
        colorScheme: "gray",
        minCount: 0,
      },
    ],
  },
  required: [
    "enabled",
    "title",
    "description",
    "enrollmentPeriodIds",
    "showPrograms",
    "showWaitlist",
    "seatBands",
    "waitlistBands",
  ],
} as const;

export const IdentityAIConfigSchema = {
  oneOf: [
    {
      type: "object",
      properties: {
        enabled: {
          type: "boolean",
          enum: [false],
        },
      },
      required: ["enabled"],
    },
    {
      type: "object",
      properties: {
        enabled: {
          type: "boolean",
          enum: [true],
        },
        document_start_date: {
          type: "string",
          format: "date-time",
        },
      },
      required: ["enabled", "document_start_date"],
    },
  ],
  default: {
    enabled: false,
  },
} as const;

export const LandingPageAdditionalContentSchema = {
  type: "object",
  properties: {
    title: {
      type: "string",
      minLength: 1,
    },
    description: {
      type: "string",
      minLength: 1,
    },
  },
  required: ["title", "description"],
} as const;

export const LandingPageBannerContentSchema = {
  oneOf: [
    {
      type: "object",
      properties: {
        enabled: {
          type: "boolean",
          enum: [false],
        },
        imageUrl: {
          type: "string",
        },
        title: {
          type: "string",
        },
        description: {
          type: "string",
        },
      },
      required: ["enabled"],
    },
    {
      type: "object",
      properties: {
        enabled: {
          type: "boolean",
          enum: [true],
        },
        imageUrl: {
          type: "string",
          format: "uri",
        },
        title: {
          type: "string",
          minLength: 1,
        },
        description: {
          type: "string",
          minLength: 1,
        },
      },
      required: ["enabled", "imageUrl", "title", "description"],
    },
  ],
} as const;

export const LandingPageCardSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/LandingPageFamilyCard",
    },
    {
      $ref: "#/components/schemas/LandingPageStaffCard",
    },
  ],
  discriminator: {
    propertyName: "kind",
    mapping: {
      family: "#/components/schemas/LandingPageFamilyCard",
      staff: "#/components/schemas/LandingPageStaffCard",
    },
  },
} as const;

export const LandingPageConfigSchema = {
  type: "object",
  properties: {
    disabled: {
      type: "boolean",
    },
    banner: {
      $ref: "#/components/schemas/LandingPageBannerContent",
    },
    welcomeCards: {
      type: "array",
      items: {
        $ref: "#/components/schemas/LandingPageCard",
      },
    },
    additionalContents: {
      type: "array",
      items: {
        $ref: "#/components/schemas/LandingPageAdditionalContent",
      },
    },
  },
} as const;

export const LandingPageFamilyCardSchema = {
  type: "object",
  properties: {
    title: {
      type: "string",
      minLength: 1,
    },
    description: {
      type: "string",
      minLength: 1,
    },
    kind: {
      type: "string",
      enum: ["family"],
    },
    contents: {
      type: "array",
      items: {
        $ref: "#/components/schemas/LandingPageFamilyContent",
      },
    },
  },
  required: ["title", "description", "kind", "contents"],
} as const;

export const LandingPageFamilyContentSchema = {
  type: "object",
  properties: {
    kind: {
      anyOf: [
        {
          type: "string",
          enum: ["family-login-button"],
        },
        {
          type: "string",
          enum: ["family-signup-button"],
        },
        {
          type: "string",
          enum: ["account-lookup-button"],
        },
        {
          type: "string",
          enum: ["custom-content"],
        },
      ],
    },
    content: {
      type: "string",
    },
  },
  required: ["kind", "content"],
} as const;

export const LandingPageStaffCardSchema = {
  type: "object",
  properties: {
    title: {
      type: "string",
      minLength: 1,
    },
    description: {
      type: "string",
      minLength: 1,
    },
    kind: {
      type: "string",
      enum: ["staff"],
    },
    contents: {
      type: "array",
      items: {
        $ref: "#/components/schemas/LandingPageStaffContent",
      },
    },
  },
  required: ["title", "description", "kind", "contents"],
} as const;

export const LandingPageStaffContentSchema = {
  type: "object",
  properties: {
    kind: {
      anyOf: [
        {
          type: "string",
          enum: ["staff-login-button"],
        },
        {
          type: "string",
          enum: ["custom-content"],
        },
      ],
    },
    content: {
      type: "string",
    },
  },
  required: ["kind", "content"],
} as const;

export const LinkContactSchema = {
  type: "object",
  properties: {
    label: {
      type: "string",
      minLength: 1,
      maxLength: 60,
    },
    type: {
      type: "string",
      enum: ["link"],
    },
    value: {
      type: "string",
      maxLength: 2048,
      format: "uri",
    },
  },
  required: ["label", "type", "value"],
} as const;

export const LoginConfigSchema = {
  type: "object",
  properties: {
    disabled: {
      type: "boolean",
    },
    admin: {
      type: "array",
      items: {
        $ref: "#/components/schemas/AdminLogin",
      },
    },
    parent: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ParentLogin",
      },
    },
  },
  default: {
    admin: [
      {
        method: "email",
      },
    ],
    parent: [
      {
        method: "email",
      },
      {
        method: "sms",
      },
    ],
  },
  required: ["admin", "parent"],
} as const;

export const LoginMethodSchema = {
  anyOf: [
    {
      $ref: "#/components/schemas/SSOLogin",
    },
    {
      $ref: "#/components/schemas/EmailLogin",
    },
    {
      $ref: "#/components/schemas/SMSLogin",
    },
  ],
} as const;

export const MatchConfigSchema = {
  oneOf: [
    {
      type: "object",
      properties: {
        disabled: {
          type: "boolean",
          enum: [true],
        },
      },
      required: ["disabled"],
    },
    {
      type: "object",
      properties: {
        disabled: {
          type: "boolean",
          enum: [false],
        },
      },
    },
  ],
} as const;

export const MfaConfigSchema = {
  type: "object",
  properties: {
    disabled: {
      type: "boolean",
    },
    enabledFactors: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MfaFactor",
      },
    },
  },
  default: {
    disabled: false,
    enabledFactors: ["otp", "phone"],
  },
  required: ["enabledFactors"],
} as const;

export const MfaFactorSchema = {
  anyOf: [
    {
      type: "string",
      enum: ["otp"],
    },
    {
      type: "string",
      enum: ["phone"],
    },
    {
      type: "string",
      enum: ["email"],
    },
  ],
} as const;

export const OrgConfigSchema = {
  anyOf: [
    {
      $ref: "#/components/schemas/MfaConfig",
    },
    {
      $ref: "#/components/schemas/LandingPageConfig",
    },
    {
      $ref: "#/components/schemas/LoginConfig",
    },
    {
      $ref: "#/components/schemas/AccountLookupConfig",
    },
    {
      $ref: "#/components/schemas/MatchConfig",
    },
    {
      $ref: "#/components/schemas/TranslationOptionsConfig",
    },
    {
      $ref: "#/components/schemas/BrandingConfig",
    },
    {
      $ref: "#/components/schemas/ContactsConfig",
    },
    {
      $ref: "#/components/schemas/Auth0Config",
    },
    {
      $ref: "#/components/schemas/AvelaAIConfig",
    },
    {
      $ref: "#/components/schemas/IdentityAIConfig",
    },
    {
      $ref: "#/components/schemas/Payments",
    },
    {
      $ref: "#/components/schemas/ExternalCapacity",
    },
  ],
} as const;

export const OrgConfigTypeSchema = {
  type: "string",
  enum: [
    "Login",
    "AccountLookup",
    "Match",
    "TranslationOptions",
    "Branding",
    "Contacts",
    "Auth0",
    "AvelaAI",
    "IdentityAI",
    "Payments",
    "ExternalCapacity",
    "LandingPage",
    "Mfa",
  ],
} as const;

export const ParentLoginSchema = {
  oneOf: [
    {
      $ref: "#/components/schemas/SSOLogin",
    },
    {
      $ref: "#/components/schemas/EmailLogin",
    },
    {
      $ref: "#/components/schemas/SMSLogin",
    },
  ],
  discriminator: {
    propertyName: "method",
    mapping: {
      sso: "#/components/schemas/SSOLogin",
      email: "#/components/schemas/EmailLogin",
      sms: "#/components/schemas/SMSLogin",
    },
  },
} as const;

export const PaymentsSchema = {
  oneOf: [
    {
      type: "object",
      properties: {
        enabled: {
          type: "boolean",
          enum: [false],
        },
        accountId: {
          type: "string",
        },
      },
      required: ["enabled"],
    },
    {
      type: "object",
      properties: {
        enabled: {
          type: "boolean",
          enum: [true],
        },
        accountId: {
          type: "string",
        },
      },
      required: ["enabled"],
    },
  ],
  default: {
    enabled: false,
  },
} as const;

export const PhoneContactSchema = {
  type: "object",
  properties: {
    label: {
      type: "string",
      minLength: 1,
      maxLength: 60,
    },
    type: {
      type: "string",
      enum: ["phone"],
    },
    value: {
      type: "string",
      minLength: 1,
    },
  },
  required: ["label", "type", "value"],
} as const;

export const SMSLoginSchema = {
  type: "object",
  properties: {
    method: {
      type: "string",
      enum: ["sms"],
    },
  },
  required: ["method"],
} as const;

export const SSOLoginSchema = {
  type: "object",
  properties: {
    name: {
      type: "string",
      minLength: 1,
    },
    method: {
      type: "string",
      enum: ["sso"],
    },
    identityProvider: {
      type: "string",
      minLength: 1,
    },
  },
  required: ["name", "method", "identityProvider"],
} as const;

export const TranslationOptionsConfigSchema = {
  oneOf: [
    {
      type: "object",
      properties: {
        disabled: {
          type: "boolean",
          enum: [true],
        },
        languages: {
          type: "array",
          items: {
            type: "string",
          },
        },
      },
      required: ["disabled", "languages"],
    },
    {
      type: "object",
      properties: {
        disabled: {
          type: "boolean",
          enum: [false],
        },
        languages: {
          type: "array",
          items: {
            type: "string",
          },
          minItems: 1,
        },
      },
      required: ["languages"],
    },
  ],
  default: {
    languages: ["en", "es"],
  },
} as const;
